import { memo } from "react";
import { generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import type { FeatureTabItemType } from "@/components/features/_layouts";
import { FeatureIslandHeaderAndTab } from "@/components/features/_layouts";

const tabArray = (hotelID: string) =>
	[
		{
			tabTitle: "スナック一覧",
			path: generatePath(PATHS.HOTEL.RESERVATION_PAGE.SNACK.LIST, { hotelID }),
		} satisfies FeatureTabItemType,
		{
			tabTitle: "設定",
			path: generatePath(PATHS.HOTEL.RESERVATION_PAGE.SNACK.SETTING, { hotelID }),
		},
	] satisfies FeatureTabItemType[];

type Props = {
	title: string;

	hotelID: string;

	headerProps?: {
		rightChildren?: React.ReactNode;
	};
};

export const DesignSnackHeaderAndTab = memo(({ title, hotelID, headerProps }: Props) => {
	return (
		<FeatureIslandHeaderAndTab
			headerProps={{ title, rightChildren: headerProps?.rightChildren }}
			tabProps={{
				tabArray: tabArray(hotelID),
			}}
		/>
	);
});

DesignSnackHeaderAndTab.displayName = "DesignSnackHeaderAndTab";
